import type { ArtifactEnvironmentDisplayInput } from '../lib/bugEnvironment'
import { artifactEnvironmentDisplay } from '../lib/bugEnvironment'
import './EnvironmentBadge.css'

export default function EnvironmentBadge({ artifact }: { artifact: ArtifactEnvironmentDisplayInput }) {
  const display = artifactEnvironmentDisplay(artifact)
  const className = `environment-badge environment-badge--${display.kind}`
  if (display.pullRequestUrl) {
    return (
      <a
        className={className}
        href={display.pullRequestUrl}
        target="_blank"
        rel="noreferrer"
        onClick={(event) => event.stopPropagation()}
        data-no-navigate
        data-testid="environment-badge"
      >
        {display.label}
      </a>
    )
  }
  return <span className={className} data-testid="environment-badge">{display.label}</span>
}
